import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '@trp-beacon-ui-kit/react-layout';

import AccountTypeDetails from '../AccountTypeDetails/AccountTypeDetails';
import { accountDetailsMap } from './AccountTypeExpander.util';
import styles from './AccountTypeExpander.css';

const AccountTypeExpander = ({ sections, defaultExpanded }) => (
    <div className="expander-container">
        <Accordion
            oneAtATime={false}
            sections={sections.map((type) => ({
                title: type.accountType,
                subText: type.subText,
                styles,
                defaultExpanded: defaultExpanded === type.expandID,
                children: (
                    <React.Fragment>
                        {accountDetailsMap[type.accountType].map((details) => (
                            <AccountTypeDetails
                                key={details.header}
                                {...details}
                            />
                        ))}
                        {type.seeAllText && (
                            <a
                                href="/personal-investing/account-finder/all-t-rowe-price-accounts.html"
                                className="see-all-link"
                            >
                                {type.seeAllText}
                            </a>
                        )}
                    </React.Fragment>
                ),
                altText: ''
            }))}
        />
        <style jsx>{styles}</style>
    </div>
);

AccountTypeExpander.defaultProps = {
    subText: ''
};

AccountTypeExpander.propTypes = {
    accountType: PropTypes.string.isRequired,
    subText: PropTypes.string
};

export default AccountTypeExpander;
